import React from 'react';

const StatusShow = ({ setStatusShowModal, statusDetails }) => {
  console.log('StatusDetails', statusDetails);

  // Function to close the modal
  const handleClose = () => {
    setStatusShowModal(false);
  };

  // Extract status from work_details instead of status_by_date
  const extractStatusesFromWorkDetails = (details) => {
    const supervisorId = Object.keys(details.supervisor_details)[0];
    const supervisorName = details.supervisor_details[supervisorId].supervisor_name;
    const statusList = [];

    details.activity.forEach(activityDay => {
      activityDay.work_details.forEach(work => {
        statusList.push({
          supervisorName,
          date: activityDay.date,
          status: work.status || 'No Status'
        });
      });
    });

    return statusList;
  };

  const supervisorStatusList = extractStatusesFromWorkDetails(statusDetails);

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
      <div className="bg-white rounded-lg shadow-lg w-[40%] p-6 relative">
        {/* Close Button */}
        <div className="p-2 pb-4 border-b-2">
          <button
            onClick={handleClose}
            className="absolute top-2 right-2 m-2 text-gray-600 hover:text-gray-900 focus:outline-none"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
              className="w-6 h-6"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M6 18L18 6M6 6l12 12"
              />
            </svg>
          </button>
        </div>

        {/* Modal Content */}
        <div className="mt-2 pt-4">
          <ul className="gap-2">
            {supervisorStatusList.length > 0 ? (
              supervisorStatusList.map((item, index) => (
                <li key={index} className="mb-2">
                  <div className="flex w-full px-4 justify-around items-center">
                    <span className="text-red-500 text-md font-semibold">
                      {item.supervisorName}
                    </span>
                    {/* <span className="text-sm text-gray-500">{item.date}</span> */}
                    <button
                      className={`ml-2 py-1 px-3 rounded-full text-xs font-inter ${
                        item.status === 'PENDING'
                          ? 'bg-[#FEF9C3] text-[#A16207]'
                          : 'bg-green-200 text-green-800'
                      }`}
                    >
                      {item.status}
                    </button>
                  </div>
                </li>
              ))
            ) : (
              <li className="text-gray-500">No status information available.</li>
            )}
          </ul>
        </div>
      </div>
    </div>
  );
};

export default StatusShow;
